<template>
    <div class="dashboard">
        <Navbar ref="navbar"/>
        <section class="my-4">
            <div class="container">
                <div class="row">
                    <div class="nav-show-btn mb-2" style="position: fixed; left: 15px; top: 10px; z-index: 1040">
                        <b-btn @click="toggleNavbar()" size="sm">Toggle Navbar</b-btn>
                    </div>
                    <div id="dashboard_nav" class="col-lg-3 col-md-4 mb-lg-0">
                        <LeftNav/>
                    </div>
                    <div id="dashboard_content" class="col-lg-9 col-md-8">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import LeftNav from "@/components/dashboard/LeftNav";

export default {
    components: {Navbar, LeftNav},
    created() {
        // this.$zendesk.hide();
        this.$store.dispatch('getOrdersForUser');
        this.$store.dispatch('getCustomersForUser');
    },
    methods: {
        toggleNavbar() {
            let $nav = document.getElementById('dashboard_nav');
            let $content = document.getElementById('dashboard_content');
            console.log($nav);

            if ($nav.classList.contains('d-none')) {
                $nav.classList.remove('d-none');
                $content.classList.remove('maxw-100');
            }
            else {
                $nav.classList.add('d-none');
                $content.classList.add('maxw-100');
            }

        },
    },
}
</script>